// El aviso de la ficha cuando las condiciones nuevas están aprobadas pero todavía no rigen (Mario, 28-oct).
// Sin tipos complejos: test/liquidacion-textos-release-28.test.mjs lo carga sin typescript.

const codigoDe = (t: any) => (t && t.version && t.version.code) || '';

/**
 * Sin versión vigente hoy, el comercio recién puede vender desde la fecha. Con una vigente (MT-LEGACY rige desde 2000 y la
 * nueva MT-V4 empieza el 1-nov) NO: hoy rige la actual y la nueva solo empieza en esa fecha.
 */
export const textoCondicionesAprobadas = (d: any) => {
  const vigente = d && d.vigente;
  if (!vigente) return `Sus condiciones ya están aprobadas y rigen desde el ${d.rige}: desde ese día puede vender y se le factura.`;
  const hoy = codigoDe(vigente);
  const nueva = codigoDe(d.proxima);
  return `Hoy rige ${hoy || 'su versión actual'}${nueva ? `; ${nueva} ya está aprobada` : '; la nueva ya está aprobada'} y empieza el ${d.rige}.`;
};
